/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExcelUploadComponent} from './excel-upload.component';
import {ExcelUploadModalComponent} from './excel-upload-modal/excel-upload-modal.component';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {ExcelDownloadModule} from '../excel-download/excel-download.module';
import {ConfirmModalComponent} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.component';

@NgModule({
    declarations: [ExcelUploadComponent, ExcelUploadModalComponent],
    exports: [
        ExcelUploadComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        ExcelDownloadModule,

    ]
})
export class ExcelUploadModule {
}
